// AUTOGENERATED — do not edit. Source: schemas/modes/verb_fx.json. Run `bun run codegen/generate.ts` to regenerate.
import type { ModeSchema } from './types';

export interface VerbFxParams {
  readonly fb_delay_xfade: number;
  readonly lp0_fb: number;
  readonly lp0_cutoff: number;
  readonly lp1_fb: number;
  readonly lp1_cutoff: number;
  readonly lp2_fb: number;
  readonly lp2_cutoff: number;
  readonly lp3_fb: number;
  readonly lp3_cutoff: number;
  readonly lp4_fb: number;
  readonly lp4_cutoff: number;
  readonly lp5_fb: number;
  readonly lp5_cutoff: number;
  readonly lp6_fb: number;
  readonly lp6_cutoff: number;
  readonly lp7_fb: number;
  readonly lp7_cutoff: number;
  readonly allp0_fb: number;
  readonly allp1_fb: number;
  readonly allp2_fb: number;
  readonly allp3_fb: number;
  readonly fbank_f0: number;
  readonly fbank_f1: number;
  readonly fbank_f2: number;
  readonly fbank_f3: number;
  readonly fbank_f4: number;
  readonly fbank_f5: number;
  readonly fbank_f6: number;
  readonly fbank_f7: number;
  readonly fbank_res0: number;
  readonly fbank_res1: number;
  readonly fbank_res2: number;
  readonly fbank_res3: number;
  readonly fbank_res4: number;
  readonly fbank_res5: number;
  readonly fbank_res6: number;
  readonly fbank_res7: number;
  readonly delay0_time: number;
  readonly delay0_fb: number;
  readonly delay1_time: number;
  readonly delay1_fb: number;
  readonly delay2_time: number;
  readonly delay2_fb: number;
  readonly verb_vs_delay: number;
  readonly delay_to_verb: number;
  readonly delay_morph: number;
  readonly delay_blend: number;
}

export const VerbFxSchema: ModeSchema = {
  mode_id: 'verb_fx',
  engine_id: 'verb_fx',
  ml: {
    input_channels: [
      'joy_x',
      'joy_y',
      'joy_z',
      'joy_w',
    ],
    input_size: 4,
    hidden_layers: [
      10,
      14,
      18,
    ],
    output_size: 47,
    default_spread: 0.6,
  },
  params: [
    {
      name: 'fb_delay_xfade',
      label: 'Bank/Delay XFade',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'routing',
    },
    {
      name: 'lp0_fb',
      label: 'LP Comb 0 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp0_cutoff',
      label: 'LP Comb 0 Cutoff',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp1_fb',
      label: 'LP Comb 1 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp1_cutoff',
      label: 'LP Comb 1 Cutoff',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp2_fb',
      label: 'LP Comb 2 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp2_cutoff',
      label: 'LP Comb 2 Cutoff',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp3_fb',
      label: 'LP Comb 3 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp3_cutoff',
      label: 'LP Comb 3 Cutoff',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp4_fb',
      label: 'LP Comb 4 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp4_cutoff',
      label: 'LP Comb 4 Cutoff',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp5_fb',
      label: 'LP Comb 5 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp5_cutoff',
      label: 'LP Comb 5 Cutoff',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp6_fb',
      label: 'LP Comb 6 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp6_cutoff',
      label: 'LP Comb 6 Cutoff',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp7_fb',
      label: 'LP Comb 7 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'lp7_cutoff',
      label: 'LP Comb 7 Cutoff',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'allp0_fb',
      label: 'Allpass 0 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'allp1_fb',
      label: 'Allpass 1 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'allp2_fb',
      label: 'Allpass 2 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'allp3_fb',
      label: 'Allpass 3 FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'verb',
    },
    {
      name: 'fbank_f0',
      label: 'Filterbank Freq 0',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_f1',
      label: 'Filterbank Freq 1',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_f2',
      label: 'Filterbank Freq 2',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_f3',
      label: 'Filterbank Freq 3',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_f4',
      label: 'Filterbank Freq 4',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_f5',
      label: 'Filterbank Freq 5',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_f6',
      label: 'Filterbank Freq 6',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_f7',
      label: 'Filterbank Freq 7',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_res0',
      label: 'Filterbank Res 0',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_res1',
      label: 'Filterbank Res 1',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_res2',
      label: 'Filterbank Res 2',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_res3',
      label: 'Filterbank Res 3',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_res4',
      label: 'Filterbank Res 4',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_res5',
      label: 'Filterbank Res 5',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_res6',
      label: 'Filterbank Res 6',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'fbank_res7',
      label: 'Filterbank Res 7',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'filterbank',
    },
    {
      name: 'delay0_time',
      label: 'Long Delay Time',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'delays',
    },
    {
      name: 'delay0_fb',
      label: 'Long Delay FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'delays',
    },
    {
      name: 'delay1_time',
      label: 'Med Delay Time',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'delays',
    },
    {
      name: 'delay1_fb',
      label: 'Med Delay FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'delays',
    },
    {
      name: 'delay2_time',
      label: 'Short Delay Time',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'delays',
    },
    {
      name: 'delay2_fb',
      label: 'Short Delay FB',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'delays',
    },
    {
      name: 'verb_vs_delay',
      label: 'Verb vs Delay',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'routing',
    },
    {
      name: 'delay_to_verb',
      label: 'Delay→Verb Send',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'routing',
    },
    {
      name: 'delay_morph',
      label: 'Delay Morph',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'delays',
    },
    {
      name: 'delay_blend',
      label: 'Delay Blend',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'delays',
    },
  ],
  voice_spaces: [
    'Default',
    'Resonant',
    'Soft',
    'Cathedral',
    'Shimmer',
    'Chamber',
    'Metallic',
    'Granular',
    'Diffuse',
    'Dark',
    'Bright',
    'Harmonic',
  ],
  curve_overrides: [
    { voice_space: 1, param: 29, curve: 'sqrt' },  // Resonant.fbank_res0
    { voice_space: 1, param: 30, curve: 'sqrt' },  // Resonant.fbank_res1
    { voice_space: 1, param: 31, curve: 'sqrt' },  // Resonant.fbank_res2
    { voice_space: 1, param: 32, curve: 'sqrt' },  // Resonant.fbank_res3
    { voice_space: 1, param: 33, curve: 'sqrt' },  // Resonant.fbank_res4
    { voice_space: 1, param: 34, curve: 'sqrt' },  // Resonant.fbank_res5
    { voice_space: 1, param: 35, curve: 'sqrt' },  // Resonant.fbank_res6
    { voice_space: 1, param: 36, curve: 'sqrt' },  // Resonant.fbank_res7
    { voice_space: 2, param: 1, curve: 'square' },  // Soft.lp0_fb
    { voice_space: 2, param: 3, curve: 'square' },  // Soft.lp1_fb
    { voice_space: 2, param: 5, curve: 'square' },  // Soft.lp2_fb
    { voice_space: 2, param: 7, curve: 'square' },  // Soft.lp3_fb
    { voice_space: 2, param: 9, curve: 'square' },  // Soft.lp4_fb
    { voice_space: 2, param: 11, curve: 'square' },  // Soft.lp5_fb
    { voice_space: 2, param: 13, curve: 'square' },  // Soft.lp6_fb
    { voice_space: 2, param: 15, curve: 'square' },  // Soft.lp7_fb
    { voice_space: 2, param: 17, curve: 'square' },  // Soft.allp0_fb
    { voice_space: 2, param: 18, curve: 'square' },  // Soft.allp1_fb
    { voice_space: 2, param: 19, curve: 'square' },  // Soft.allp2_fb
    { voice_space: 2, param: 20, curve: 'square' },  // Soft.allp3_fb
    { voice_space: 2, param: 29, curve: 'square' },  // Soft.fbank_res0
    { voice_space: 2, param: 30, curve: 'square' },  // Soft.fbank_res1
    { voice_space: 2, param: 31, curve: 'square' },  // Soft.fbank_res2
    { voice_space: 2, param: 32, curve: 'square' },  // Soft.fbank_res3
    { voice_space: 2, param: 33, curve: 'square' },  // Soft.fbank_res4
    { voice_space: 2, param: 34, curve: 'square' },  // Soft.fbank_res5
    { voice_space: 2, param: 35, curve: 'square' },  // Soft.fbank_res6
    { voice_space: 2, param: 36, curve: 'square' },  // Soft.fbank_res7
    { voice_space: 2, param: 38, curve: 'square' },  // Soft.delay0_fb
    { voice_space: 2, param: 40, curve: 'square' },  // Soft.delay1_fb
    { voice_space: 2, param: 42, curve: 'square' },  // Soft.delay2_fb
    { voice_space: 3, param: 1, curve: 'sqrt' },  // Cathedral.lp0_fb
    { voice_space: 3, param: 3, curve: 'sqrt' },  // Cathedral.lp1_fb
    { voice_space: 3, param: 5, curve: 'sqrt' },  // Cathedral.lp2_fb
    { voice_space: 3, param: 7, curve: 'sqrt' },  // Cathedral.lp3_fb
    { voice_space: 3, param: 9, curve: 'sqrt' },  // Cathedral.lp4_fb
    { voice_space: 3, param: 11, curve: 'sqrt' },  // Cathedral.lp5_fb
    { voice_space: 3, param: 13, curve: 'sqrt' },  // Cathedral.lp6_fb
    { voice_space: 3, param: 15, curve: 'sqrt' },  // Cathedral.lp7_fb
    { voice_space: 3, param: 17, curve: 'sqrt' },  // Cathedral.allp0_fb
    { voice_space: 3, param: 18, curve: 'sqrt' },  // Cathedral.allp1_fb
    { voice_space: 3, param: 19, curve: 'sqrt' },  // Cathedral.allp2_fb
    { voice_space: 3, param: 20, curve: 'sqrt' },  // Cathedral.allp3_fb
    { voice_space: 3, param: 37, curve: 'sqrt' },  // Cathedral.delay0_time
    { voice_space: 3, param: 38, curve: 'sqrt' },  // Cathedral.delay0_fb
    { voice_space: 3, param: 39, curve: 'sqrt' },  // Cathedral.delay1_time
    { voice_space: 3, param: 40, curve: 'sqrt' },  // Cathedral.delay1_fb
    { voice_space: 3, param: 41, curve: 'sqrt' },  // Cathedral.delay2_time
    { voice_space: 3, param: 42, curve: 'sqrt' },  // Cathedral.delay2_fb
    { voice_space: 3, param: 43, curve: 'square' },  // Cathedral.verb_vs_delay
    { voice_space: 4, param: 1, curve: 'sqrt' },  // Shimmer.lp0_fb
    { voice_space: 4, param: 3, curve: 'sqrt' },  // Shimmer.lp1_fb
    { voice_space: 4, param: 5, curve: 'sqrt' },  // Shimmer.lp2_fb
    { voice_space: 4, param: 7, curve: 'sqrt' },  // Shimmer.lp3_fb
    { voice_space: 4, param: 9, curve: 'sqrt' },  // Shimmer.lp4_fb
    { voice_space: 4, param: 11, curve: 'sqrt' },  // Shimmer.lp5_fb
    { voice_space: 4, param: 13, curve: 'sqrt' },  // Shimmer.lp6_fb
    { voice_space: 4, param: 15, curve: 'sqrt' },  // Shimmer.lp7_fb
    { voice_space: 4, param: 17, curve: 'sqrt' },  // Shimmer.allp0_fb
    { voice_space: 4, param: 18, curve: 'sqrt' },  // Shimmer.allp1_fb
    { voice_space: 4, param: 19, curve: 'sqrt' },  // Shimmer.allp2_fb
    { voice_space: 4, param: 20, curve: 'sqrt' },  // Shimmer.allp3_fb
    { voice_space: 4, param: 29, curve: 'sqrt' },  // Shimmer.fbank_res0
    { voice_space: 4, param: 30, curve: 'sqrt' },  // Shimmer.fbank_res1
    { voice_space: 4, param: 31, curve: 'sqrt' },  // Shimmer.fbank_res2
    { voice_space: 4, param: 32, curve: 'sqrt' },  // Shimmer.fbank_res3
    { voice_space: 4, param: 33, curve: 'sqrt' },  // Shimmer.fbank_res4
    { voice_space: 4, param: 34, curve: 'sqrt' },  // Shimmer.fbank_res5
    { voice_space: 4, param: 35, curve: 'sqrt' },  // Shimmer.fbank_res6
    { voice_space: 4, param: 36, curve: 'sqrt' },  // Shimmer.fbank_res7
    { voice_space: 4, param: 38, curve: 'sqrt' },  // Shimmer.delay0_fb
    { voice_space: 4, param: 40, curve: 'sqrt' },  // Shimmer.delay1_fb
    { voice_space: 4, param: 42, curve: 'sqrt' },  // Shimmer.delay2_fb
    { voice_space: 4, param: 43, curve: 'square' },  // Shimmer.verb_vs_delay
    { voice_space: 5, param: 1, curve: 'square' },  // Chamber.lp0_fb
    { voice_space: 5, param: 3, curve: 'square' },  // Chamber.lp1_fb
    { voice_space: 5, param: 5, curve: 'square' },  // Chamber.lp2_fb
    { voice_space: 5, param: 7, curve: 'square' },  // Chamber.lp3_fb
    { voice_space: 5, param: 9, curve: 'square' },  // Chamber.lp4_fb
    { voice_space: 5, param: 11, curve: 'square' },  // Chamber.lp5_fb
    { voice_space: 5, param: 13, curve: 'square' },  // Chamber.lp6_fb
    { voice_space: 5, param: 15, curve: 'square' },  // Chamber.lp7_fb
    { voice_space: 5, param: 17, curve: 'square' },  // Chamber.allp0_fb
    { voice_space: 5, param: 18, curve: 'square' },  // Chamber.allp1_fb
    { voice_space: 5, param: 19, curve: 'square' },  // Chamber.allp2_fb
    { voice_space: 5, param: 20, curve: 'square' },  // Chamber.allp3_fb
    { voice_space: 5, param: 29, curve: 'square' },  // Chamber.fbank_res0
    { voice_space: 5, param: 30, curve: 'square' },  // Chamber.fbank_res1
    { voice_space: 5, param: 31, curve: 'square' },  // Chamber.fbank_res2
    { voice_space: 5, param: 32, curve: 'square' },  // Chamber.fbank_res3
    { voice_space: 5, param: 33, curve: 'square' },  // Chamber.fbank_res4
    { voice_space: 5, param: 34, curve: 'square' },  // Chamber.fbank_res5
    { voice_space: 5, param: 35, curve: 'square' },  // Chamber.fbank_res6
    { voice_space: 5, param: 36, curve: 'square' },  // Chamber.fbank_res7
    { voice_space: 5, param: 37, curve: 'square' },  // Chamber.delay0_time
    { voice_space: 5, param: 38, curve: 'square' },  // Chamber.delay0_fb
    { voice_space: 5, param: 39, curve: 'square' },  // Chamber.delay1_time
    { voice_space: 5, param: 40, curve: 'square' },  // Chamber.delay1_fb
    { voice_space: 5, param: 41, curve: 'square' },  // Chamber.delay2_time
    { voice_space: 5, param: 42, curve: 'square' },  // Chamber.delay2_fb
    { voice_space: 6, param: 17, curve: 'sqrt' },  // Metallic.allp0_fb
    { voice_space: 6, param: 18, curve: 'sqrt' },  // Metallic.allp1_fb
    { voice_space: 6, param: 19, curve: 'sqrt' },  // Metallic.allp2_fb
    { voice_space: 6, param: 20, curve: 'sqrt' },  // Metallic.allp3_fb
    { voice_space: 6, param: 29, curve: 'sqrt' },  // Metallic.fbank_res0
    { voice_space: 6, param: 30, curve: 'square' },  // Metallic.fbank_res1
    { voice_space: 6, param: 31, curve: 'sqrt' },  // Metallic.fbank_res2
    { voice_space: 6, param: 32, curve: 'square' },  // Metallic.fbank_res3
    { voice_space: 6, param: 33, curve: 'sqrt' },  // Metallic.fbank_res4
    { voice_space: 6, param: 34, curve: 'square' },  // Metallic.fbank_res5
    { voice_space: 6, param: 35, curve: 'sqrt' },  // Metallic.fbank_res6
    { voice_space: 6, param: 36, curve: 'square' },  // Metallic.fbank_res7
    { voice_space: 7, param: 1, curve: 'square' },  // Granular.lp0_fb
    { voice_space: 7, param: 3, curve: 'square' },  // Granular.lp1_fb
    { voice_space: 7, param: 5, curve: 'square' },  // Granular.lp2_fb
    { voice_space: 7, param: 7, curve: 'square' },  // Granular.lp3_fb
    { voice_space: 7, param: 9, curve: 'square' },  // Granular.lp4_fb
    { voice_space: 7, param: 11, curve: 'square' },  // Granular.lp5_fb
    { voice_space: 7, param: 13, curve: 'square' },  // Granular.lp6_fb
    { voice_space: 7, param: 15, curve: 'square' },  // Granular.lp7_fb
    { voice_space: 7, param: 17, curve: 'square' },  // Granular.allp0_fb
    { voice_space: 7, param: 18, curve: 'square' },  // Granular.allp1_fb
    { voice_space: 7, param: 19, curve: 'square' },  // Granular.allp2_fb
    { voice_space: 7, param: 20, curve: 'square' },  // Granular.allp3_fb
    { voice_space: 7, param: 29, curve: 'square' },  // Granular.fbank_res0
    { voice_space: 7, param: 30, curve: 'square' },  // Granular.fbank_res1
    { voice_space: 7, param: 31, curve: 'square' },  // Granular.fbank_res2
    { voice_space: 7, param: 32, curve: 'square' },  // Granular.fbank_res3
    { voice_space: 7, param: 33, curve: 'square' },  // Granular.fbank_res4
    { voice_space: 7, param: 34, curve: 'square' },  // Granular.fbank_res5
    { voice_space: 7, param: 35, curve: 'square' },  // Granular.fbank_res6
    { voice_space: 7, param: 36, curve: 'square' },  // Granular.fbank_res7
    { voice_space: 7, param: 38, curve: 'square' },  // Granular.delay0_fb
    { voice_space: 7, param: 40, curve: 'square' },  // Granular.delay1_fb
    { voice_space: 7, param: 42, curve: 'sqrt' },  // Granular.delay2_fb
    { voice_space: 7, param: 43, curve: 'sqrt' },  // Granular.verb_vs_delay
    { voice_space: 7, param: 45, curve: 'square' },  // Granular.delay_morph
    { voice_space: 7, param: 46, curve: 'sqrt' },  // Granular.delay_blend
    { voice_space: 8, param: 0, curve: 'sqrt' },  // Diffuse.fb_delay_xfade
    { voice_space: 8, param: 17, curve: 'sqrt' },  // Diffuse.allp0_fb
    { voice_space: 8, param: 18, curve: 'sqrt' },  // Diffuse.allp1_fb
    { voice_space: 8, param: 19, curve: 'sqrt' },  // Diffuse.allp2_fb
    { voice_space: 8, param: 20, curve: 'sqrt' },  // Diffuse.allp3_fb
    { voice_space: 8, param: 29, curve: 'square' },  // Diffuse.fbank_res0
    { voice_space: 8, param: 30, curve: 'square' },  // Diffuse.fbank_res1
    { voice_space: 8, param: 31, curve: 'square' },  // Diffuse.fbank_res2
    { voice_space: 8, param: 32, curve: 'square' },  // Diffuse.fbank_res3
    { voice_space: 8, param: 33, curve: 'square' },  // Diffuse.fbank_res4
    { voice_space: 8, param: 34, curve: 'square' },  // Diffuse.fbank_res5
    { voice_space: 8, param: 35, curve: 'square' },  // Diffuse.fbank_res6
    { voice_space: 8, param: 36, curve: 'square' },  // Diffuse.fbank_res7
    { voice_space: 8, param: 38, curve: 'sqrt' },  // Diffuse.delay0_fb
    { voice_space: 8, param: 40, curve: 'sqrt' },  // Diffuse.delay1_fb
    { voice_space: 8, param: 42, curve: 'sqrt' },  // Diffuse.delay2_fb
    { voice_space: 9, param: 21, curve: 'square' },  // Dark.fbank_f0
    { voice_space: 9, param: 22, curve: 'square' },  // Dark.fbank_f1
    { voice_space: 9, param: 23, curve: 'square' },  // Dark.fbank_f2
    { voice_space: 9, param: 24, curve: 'square' },  // Dark.fbank_f3
    { voice_space: 9, param: 25, curve: 'square' },  // Dark.fbank_f4
    { voice_space: 9, param: 26, curve: 'square' },  // Dark.fbank_f5
    { voice_space: 9, param: 27, curve: 'square' },  // Dark.fbank_f6
    { voice_space: 9, param: 28, curve: 'square' },  // Dark.fbank_f7
    { voice_space: 9, param: 29, curve: 'sqrt' },  // Dark.fbank_res0
    { voice_space: 9, param: 30, curve: 'sqrt' },  // Dark.fbank_res1
    { voice_space: 9, param: 31, curve: 'sqrt' },  // Dark.fbank_res2
    { voice_space: 9, param: 32, curve: 'sqrt' },  // Dark.fbank_res3
    { voice_space: 9, param: 33, curve: 'square' },  // Dark.fbank_res4
    { voice_space: 9, param: 34, curve: 'square' },  // Dark.fbank_res5
    { voice_space: 9, param: 35, curve: 'square' },  // Dark.fbank_res6
    { voice_space: 9, param: 36, curve: 'square' },  // Dark.fbank_res7
    { voice_space: 10, param: 21, curve: 'sqrt' },  // Bright.fbank_f0
    { voice_space: 10, param: 22, curve: 'sqrt' },  // Bright.fbank_f1
    { voice_space: 10, param: 23, curve: 'sqrt' },  // Bright.fbank_f2
    { voice_space: 10, param: 24, curve: 'sqrt' },  // Bright.fbank_f3
    { voice_space: 10, param: 25, curve: 'sqrt' },  // Bright.fbank_f4
    { voice_space: 10, param: 26, curve: 'sqrt' },  // Bright.fbank_f5
    { voice_space: 10, param: 27, curve: 'sqrt' },  // Bright.fbank_f6
    { voice_space: 10, param: 28, curve: 'sqrt' },  // Bright.fbank_f7
    { voice_space: 10, param: 29, curve: 'square' },  // Bright.fbank_res0
    { voice_space: 10, param: 30, curve: 'square' },  // Bright.fbank_res1
    { voice_space: 10, param: 31, curve: 'square' },  // Bright.fbank_res2
    { voice_space: 10, param: 32, curve: 'square' },  // Bright.fbank_res3
    { voice_space: 10, param: 33, curve: 'sqrt' },  // Bright.fbank_res4
    { voice_space: 10, param: 34, curve: 'sqrt' },  // Bright.fbank_res5
    { voice_space: 10, param: 35, curve: 'sqrt' },  // Bright.fbank_res6
    { voice_space: 10, param: 36, curve: 'sqrt' },  // Bright.fbank_res7
    { voice_space: 11, param: 29, curve: 'sqrt' },  // Harmonic.fbank_res0
    { voice_space: 11, param: 30, curve: 'sqrt' },  // Harmonic.fbank_res1
    { voice_space: 11, param: 31, curve: 'sqrt' },  // Harmonic.fbank_res2
    { voice_space: 11, param: 32, curve: 'sqrt' },  // Harmonic.fbank_res3
    { voice_space: 11, param: 33, curve: 'sqrt' },  // Harmonic.fbank_res4
    { voice_space: 11, param: 34, curve: 'sqrt' },  // Harmonic.fbank_res5
    { voice_space: 11, param: 35, curve: 'sqrt' },  // Harmonic.fbank_res6
    { voice_space: 11, param: 36, curve: 'sqrt' },  // Harmonic.fbank_res7
  ],
  ui: {
    primary_input: 'joystick',
    show_voice_space_selector: true,
    show_synth_visualizer: false,
  },
};
